import styled from "styled-components";
import theme from "styles/theme";

export const LayoutContent = styled.div`
  padding: 30px 24px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 3px 10px ${(props) => props.theme["@box-shadow"]};
`;

export const LayoutBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  > h1 {
    display: flex;
    align-items: center;
    margin: 0 0 0 10px;
    font-family: ${(props) => props.theme["@font-family"]};
  }
`;

export const Title: React.CSSProperties = {
  margin: "9px 0",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@font-size-title-page"],
  fontFamily: theme["@font-family"],
};

export const Content: React.CSSProperties = {
  margin: "70px 26px",
};
